// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnMApiModel$PorterinFeature from "../api-model/PnMApiModel.mjs";
import * as PnMVmMapper$PorterinFeature from "./PnMVmMapper.mjs";
import * as SEOConstants$PorterinFeature from "../../../../shared/core/constants/SEOConstants.mjs";
import * as SharedEntityMapper$PorterinFeature from "../../../../shared/core/domain/entity-mappers/SharedEntityMapper.mjs";

function apiModelToState(response) {
  var value = response.show_house_field;
  var seo = response.section_seo;
  var download = response.section_download;
  var section = response.section_addition_service;
  var pointerSection = response.section_pointers;
  var wrapper = response.section_testimonials;
  return {
          page_path: response.page_path,
          city_label: response.city_label,
          show_house_field: value !== undefined ? value : false,
          meta_data: SharedEntityMapper$PorterinFeature.getMeta(response.meta_data, SEOConstants$PorterinFeature.defaultSeoTitleDesc.text, SEOConstants$PorterinFeature.defaultSeoTitleDesc.sub_text),
          hero_section: PnMVmMapper$PorterinFeature.getPnMHeroSection(response.hero_section, response.section_banner),
          section_seo: seo !== undefined ? ({
                text: seo.text,
                sub_text: seo.sub_text
              }) : ({
                text: "",
                sub_text: ""
              }),
          section_download: download !== undefined ? ({
                download_app_mobile: {
                  title: download.download_app_mobile.title,
                  sub_text: download.download_app_mobile.sub_text,
                  button_label: download.download_app_mobile.button_label,
                  button_href: download.download_app_mobile.button_href,
                  app_icon: {
                    path: download.download_app_mobile.app_icon.image.url,
                    alt_text: Belt_Option.getWithDefault(download.download_app_mobile.app_icon.alt, "")
                  },
                  app_store_image: {
                    path: download.download_app_mobile.app_store_image.image.url,
                    alt_text: Belt_Option.getWithDefault(download.download_app_mobile.app_store_image.alt, "")
                  },
                  google_play_store_image: {
                    path: download.download_app_mobile.google_play_store_image.image.url,
                    alt_text: Belt_Option.getWithDefault(download.download_app_mobile.google_play_store_image.alt, "")
                  }
                },
                download_app_desktop: {
                  title: download.download_app_desktop.title,
                  sub_title: download.download_app_desktop.sub_title,
                  qr_text: download.download_app_desktop.qr_text,
                  qr: {
                    path: download.download_app_desktop.qr.image.url,
                    alt_text: Belt_Option.getWithDefault(download.download_app_desktop.qr.alt, "")
                  }
                }
              }) : ({
                download_app_mobile: {
                  title: "",
                  sub_text: "",
                  button_label: "",
                  button_href: "",
                  app_icon: {
                    path: "",
                    alt_text: ""
                  },
                  app_store_image: {
                    path: "",
                    alt_text: ""
                  },
                  google_play_store_image: {
                    path: "",
                    alt_text: ""
                  }
                },
                download_app_desktop: {
                  title: "",
                  sub_title: "",
                  qr_text: "",
                  qr: {
                    path: "",
                    alt_text: ""
                  }
                }
              }),
          city_content: {
            cities: PnMVmMapper$PorterinFeature.getPnMCities(response.cities),
            city_name: "",
            city_label: response.city_label
          },
          faqs_section: PnMVmMapper$PorterinFeature.getPnMFaqsSection(response.section_faqs),
          section_addition_service: section !== undefined ? PnMVmMapper$PorterinFeature.mapAdditionService(section) : ({
                text: "",
                sub_text: "",
                pointers: []
              }),
          section_pointers: pointerSection !== undefined ? PnMVmMapper$PorterinFeature.mapAdditionService(pointerSection) : ({
                text: "",
                sub_text: "",
                pointers: []
              }),
          section_testimonials: wrapper !== undefined ? ({
                title: wrapper.testimonials_section.title,
                testimonials: Belt_Array.map(wrapper.testimonials_section.testimonials, PnMVmMapper$PorterinFeature.mapTestimonial)
              }) : ({
                title: "",
                testimonials: []
              }),
          section_internal_links: PnMVmMapper$PorterinFeature.getInternalLinksSectionFlat(response.section_internal_links)
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PnMApiModel$PorterinFeature.t_decode(json), "PnMEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
